import React from "react"
import classNames from "classnames"

import VotableComponent from "./votable-component"
import HeartImage from "../../static/images/heart.png"
import HeartDeselectedImage from "../../static/images/heart_deselected.png"

class Comment extends VotableComponent {

  constructor(props) {
    super(props)
    this.state.showFullText = false
  }

  toggleshowFullText = (e) => {
    this.setState({
      showFullText: true
    })
    e.preventDefault();
    
  }

  renderComment = () => {
    const { data } = this.props
    const hasEllipsis = !!data.readMore
    const ellipsisClassNames = classNames("has-ellipsis is-off-desktop", {
      "is-off":  this.state.showFullText
    })

    if (hasEllipsis) {
      return (
        <p className={ ellipsisClassNames }>
          { data.description }
          <span className="ellipsis">...</span> <span className="ellipsis-text">
          { data.readMore }
          </span> 
          <a onClick={ this.toggleshowFullText } href="" className="read-more">Read more</a>
        </p>
      )
    } 

    return (
      <p>{ data.description }</p>
    )
  }


  render() {
    const { data, isHidden, siteUrl } = this.props
    const heartClassName = classNames("button heart-icon", {
      "liked": this.state.isLoved
    })
    const commentClassName = classNames(`suggestion nest-level-${data.tabs}`, {
      hidden: isHidden,
    })

    return (
      <div className={commentClassName}>
        <div className="wrapper">
          <div className="avatar medium">
            <img src={`${siteUrl}/${data.avatar}`} alt="" />
          </div>
          <div className="message">
            <h4>{ data.name } <time>{ data.date }</time></h4>
            { this.renderComment() }
            <div className="actions">
              <div className="counter horizontal">
                <button 
                  className="button voting vote-up arrow"
                  onClick={ this.onLike }>
                </button>
                <span>{ this.state.currentLikes }</span>
                <button 
                  className="button voting vote-down arrow"
                  onClick={ this.onDislike }>
                </button>
              </div>
              <button 
                className={ heartClassName }
                onClick={ this.toggleIsLoved }>
                <img
                  className="deselected"
                  src={ HeartDeselectedImage }
                  alt=""
                />
                <img src={HeartImage} alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Comment
